import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import {
  updateProfile,
  getAllStates,
  getViewProfile,
} from "../../../redux/slices/profileSlice";

const LicensedStatesModal = ({
  show,
  onHide,
  value = [],
  onSave,
  shouldUpdateProfile = false,
  isApplyPage = false,
}) => {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);

  const [selectedStates, setSelectedStates] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [error, setError] = useState("");

  /* -------- FETCH STATES -------- */
  useEffect(() => {
    dispatch(getAllStates());
  }, [dispatch]);

  /* -------- MAP STATES FOR DROPDOWN -------- */
  useEffect(() => {
    if (store?.stateItems?.data?.states) {
      const options = store.stateItems.data.states.map((state) => ({
        value: state.state, // CA
        label: state.state_full_name, // California
      }));

      setStateOptions(options);
    }
  }, [store?.stateItems]);

  /* -------- LOAD EXISTING LICENSED STATES -------- */
  // useEffect(() => {
  //   if (!show) return;

  //   const current = store?.profileItem?.data?.nurseProfile?.licensed_states;

  //   if (current) {
  //     let parsed = [];

  //     try {
  //       parsed = Array.isArray(current) ? current : JSON.parse(current);
  //     } catch {
  //       parsed = current.split(",");
  //     }

  //     const formatted = parsed
  //       .map((code) => stateOptions.find((opt) => opt.value === code))
  //       .filter(Boolean);

  //     setSelectedStates(formatted);
  //   }
  // }, [show, store?.profileItem, stateOptions]);
  useEffect(() => {
    if (!show) return;

    if (isApplyPage) {
      // ✅ APPLY MODE
      const formatted = value
        .map((code) => stateOptions.find((opt) => opt.value === code))
        .filter(Boolean);

      setSelectedStates(formatted);
    } else {
      // ✅ PROFILE MODE
      const current = store?.profileItem?.data?.nurseProfile?.licensed_states;

      if (current) {
        let parsed = [];

        try {
          parsed = Array.isArray(current) ? current : JSON.parse(current);
        } catch {
          parsed = current.split(",");
        }

        const formatted = parsed
          .map((code) => stateOptions.find((opt) => opt.value === code))
          .filter(Boolean);

        setSelectedStates(formatted);
      }
    }

    // ❗ ONLY depend on show + stateOptions
  }, [show, stateOptions]);

  /* -------- SAVE -------- */
  const handleSave = () => {
    if (!selectedStates.length) {
      setError("Please select at least one state");
      return;
    }

    const values = selectedStates.map((item) => item.value);

    if (isApplyPage) {
      // ✅ ALWAYS update local
      onSave(values);

      // 🔥 ONLY call API if empty before
      if (shouldUpdateProfile) {
        const formData = new FormData();

        formData.append(
          "name",
          store?.profileItem?.data?.name ||
            store?.profileItem?.data?.full_name ||
            "",
        );

        formData.append("licensed_states", JSON.stringify(values));

        dispatch(updateProfile(formData));
      }

      onHide();
    } else {
      // ✅ Profile page → always API
      const formData = new FormData();

      formData.append(
        "name",
        store?.profileItem?.data?.name ||
          store?.profileItem?.data?.full_name ||
          "",
      );

      formData.append("licensed_states", JSON.stringify(values));

      dispatch(updateProfile(formData));
    }
  };
  // const handleSave = () => {
  //   if (!selectedStates.length) {
  //     setError("Please select at least one state");
  //     return;
  //   }

  //   const values = selectedStates.map((item) => item.value);

  //   if (isApplyPage) {
  //     // ✅ LOCAL
  //     onSave(values);
  //     onHide();
  //   } else {
  //     // ✅ API
  //     const formData = new FormData();

  //     formData.append(
  //       "name",
  //       store?.profileItem?.data?.name ||
  //         store?.profileItem?.data?.full_name ||
  //         "",
  //     );

  //     formData.append("licensed_states", JSON.stringify(values));

  //     dispatch(updateProfile(formData));
  //   }
  // };
  /* -------- CLOSE AFTER SAVE -------- */
  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      onHide();
    }
  }, [store?.actionFlag]);
  useEffect(() => {
    if (show) {
      // dispatch(getViewProfile());
    }
  }, [show, dispatch]);
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="md"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">Select Licensed States</h5>

        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <Form.Group className="form-group">
          <Form.Label className="col-label">Licensed States</Form.Label>

          <Select
            options={stateOptions}
            value={selectedStates}
            onChange={(options) => {
              setSelectedStates(options || []);
              setError("");
            }}
            isMulti
            isSearchable
            menuPosition="fixed"
            menuPortalTarget={document.body}
            styles={{
              menu: (base) => ({
                ...base,
                borderRadius: "15px",
                marginTop: "8px",
                backgroundColor: "var(--mmp-surface)",
                padding: "6px",
                zIndex: "1000",
              }),
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999,
              }),
              option: (base, state) => ({
                ...base,
                borderRadius: "8px",
                padding: "10px",
                backgroundColor: state.isFocused ? "var(--mmp-hover-bg)" : "var(--mmp-surface)",
                color: "var(--mmp-text-primary)",
                cursor: "pointer",
                "&:active": {
                  backgroundColor: "var(--mmp-hover-bg)",
                },
              }),
              multiValue: (base) => ({
                ...base,
                backgroundColor: "var(--mmp-accent-bg)",
                border: "1px solid var(--mmp-accent-border)",
                borderRadius: "6px",
              }),
              multiValueLabel: (base) => ({
                ...base,
                color: "var(--mmp-accent-hover)",
              }),
              multiValueRemove: (base) => ({
                ...base,
                color: "var(--mmp-accent-hover)",
                "&:hover": {
                  backgroundColor: "var(--mmp-danger-bg)",
                  color: "var(--mmp-danger)",
                },
              }),
            }}
            placeholder="Select states..."
            className="react-select-container"
            classNamePrefix="react-select"
          />
        </Form.Group>

        {error && <div className="error-message mt-2">{error}</div>}

        <div className="text-center mt-4">
          <Button
            className="btn-primary px-4"
            onClick={handleSave}
            disabled={store?.isLoading || selectedStates.length === 0}
          >
            {store?.isLoading ? "Saving..." : "Save"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LicensedStatesModal;
